module.exports = __webpack_public_path__ + "media/components/assets/img/pic/hut-flyo-2faa03077c01c5dedf56f3c1555968a9.svg";